import React from 'react';
import PropTypes from 'prop-types';
import plusIcon from '../../../assets/img/icons/plus-black.svg';
import minusIcon from '../../../assets/img/icons/minus.svg';
import useCollapsible from '../../hooks/useCollapsible';

export default function AuctionFilterCollapsible({
  title,
  header,
  defaultOpen = false,
  duration = 200,
  className = '',
  bodyClassName = '',
  open: controlledOpen,
  onToggle,
  children,
}) {
  const {
    contentRef,
    open,
    toggle: internalToggle,
    contentStyle,
  } = useCollapsible({
    defaultOpen,
    duration,
    open: controlledOpen,
  });

  const isControlled = typeof controlledOpen === 'boolean';
  const handleToggle = isControlled ? () => onToggle?.(!controlledOpen) : internalToggle;

  const renderHeader = () => {
    if (typeof header === 'function') return header({ open, toggle: handleToggle });
    if (typeof title === 'string')
      return <h5 className="font-semibold text-gray-800 pb-0 m-0">{title}</h5>;
    return title;
  };

  const contentId = React.useId();

  return (
    <div className={`pb-1 border-b border-gray-200 ${className}`}>
      <div className="d-flex justify-content-between align-items-center pb-3 mb-3 search-page__filters-box-criteria">
        <div className="m-0 p-0">{renderHeader()}</div>
        <button
          type="button"
          aria-expanded={open}
          aria-controls={contentId}
          onClick={handleToggle}
        >
          <img src={open ? minusIcon : plusIcon} alt={open ? 'Minus icon' : 'Plus icon'} />
        </button>
      </div>

      <div id={contentId} ref={contentRef} style={contentStyle} className={bodyClassName}>
        {children}
      </div>
    </div>
  );
}

AuctionFilterCollapsible.defaultProps = {
  title: '',
  header: null,
  defaultOpen: false,
  duration: 200,
  className: '',
  bodyClassName: '',
  open: undefined,
  onToggle: undefined,
};

AuctionFilterCollapsible.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  header: PropTypes.func,
  defaultOpen: PropTypes.bool,
  duration: PropTypes.number,
  className: PropTypes.string,
  bodyClassName: PropTypes.string,
  open: PropTypes.bool,
  onToggle: PropTypes.func,
  children: PropTypes.node.isRequired,
};
